var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('h1',{staticClass:"title"},[_vm._v("没有权限")]),_c('div',{staticClass:"header-wrap"}),_c('div',{staticClass:"tab-wrap"})])
}]

export { render, staticRenderFns }